<template>
  <div class="stats-header">
    <h2 class="stats-title">{{ title }}</h2>
    <p class="stats-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '我们为客户提供'
  },
  subtitle: {
    type: String,
    default: '专业的解决方案，全方位提升业务效率'
  }
})
</script>

<style scoped>
.stats-header {
  text-align: center;
  margin-bottom: 48px;
}

.stats-title {
  font-size: 34px;
  font-weight: 700;
  color: var(--text-color-darker);
  margin-bottom: 0;
  margin-top: 0;
  display: inline-block;
  position: relative;
}

.stats-title::after {
  content: "";
  display: block;
  width: 80%;
  height: 0;
  border-bottom: 4px solid var(--primary-color);
  margin: 14px auto 0;
  border-radius: 2px;
}

.stats-subtitle {
  margin: 16px 0 0 0;
  font-size: 18px;
  color: var(--text-color-dark-gray);
  text-align: center;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 992px) {
  .stats-subtitle {
    font-size: 16px;
  }
  .stats-title {
    font-size: 30px;
  }
}

@media (max-width: 768px) {
  .stats-subtitle {
    font-size: 15px;
    margin: 12px 0 0 0;
  }
  .stats-title {
    font-size: 26px;
  }
  .stats-header {
    margin-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .stats-title {
    font-size: 24px;
  }
}
</style>